module.exports = __webpack_public_path__ + "img/medical.81888df9.svg";